<!-- headings -->
<div class="wrap center">

    @if (visibleSections.length) {
    <h6 sizeClass="SM: h2, !SM: h1"
        *iCms="'title' of component"></h6>
    <p class="p1 m-t-1"
       *iCms="'subtitle' of component; skipEmpty: true"></p>
    <div class="flex flex-middle flex-justify-center m-t m-t-5-s m-t-5-m">
        @for (section of visibleSections; track $index; let index = $index) {
        @if (index) {
        <div class="vertical-separator m-l-3 m-r-3"></div>
        }
        <h6 class="underline s1 cursor-pointer"
            [class.cursor-pointer]="hasManySections"
            zippyClass="col-1 !col-12"
            [zippyOpen]="[uid, index]"
            [zippyOpenOff]="!hasManySections"
            *iCms="'title' of section"></h6>
        }
    </div>
    }

    <!-- contents -->
    @for (section of component.sections; track $index; let index = $index) {
    <div [hidden]="!isVisible(section)"
         [zippy]="[uid, index]"
         [zippyAuto]="isVisible(section) && hasManySections"
         [zippyOff]="!isVisible(section) || !hasManySections">
        <!-- view all button -->
        <div class="pos-relative"
             *ifSize="'XL'">
            <a class="pos-absolute s1 underline right-0 bottom-3"
               [routerLink]="section.cta_link"
               *iCms="'cta_copy' of section; skipEmpty: true"></a>
        </div>
        <!-- section products -->
        <related-products class="block m-t"
                          [source]="product"
                          [limit]="section.limit || 8"
                          [options]="getOptions(section)"
                          (isPrinted)="onPrinted($event, section, index)">
        </related-products>
    </div>
    }
</div>